// extracted by mini-css-extract-plugin
export default {"groupCard":"Groups_groupCard__-S5Rf","groupCardArrow":"Groups_groupCardArrow__WFI+V","groupCardText":"Groups_groupCardText__Jlu00","groupCardImg":"Groups_groupCardImg__sjf1Q"};